import { get, post } from '../index';

export async function getStationProjects(station, qs={}) {
    let projectsResponse = await get(`/projects/${station}/mergelist`, qs);
    return projectsResponse;
}

export function mergeStationProjects(station, unMergeRequest) {
    return post(`projects/${station}/merge`, {}, unMergeRequest);
}

export function reRunMergeProcess(station, runId) {
    return post(`projects/${station}/${runId}/rerunmerge`, {});
}

export function cancelMergeProcess(runId) {
    return post(`projects/${runId}/cancelmerge`, {});
}

export function unMergeProject(projectId, unMergeRequest) {
    return post(`projects/${projectId}/unmerge`, {}, unMergeRequest);
}
